'use client'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import CustomFetch from '@/Utils/APIRequest/AxiosInstance'
import { CardsAPI, DeleteCardAPI } from '@/Utils/APIRequest/Endpoints'
import { useTranslation } from '@/Utils/Hooks/useTranslate'
import { PayCardDeleteSVG, PayCardSVG } from '@/Component/Common/SVGs/CommonSVG'
import GradientButton from '@/Component/Common/Forms/GradientButton'
import ActivePlanStepTwo from '@/Component/Admin/AdminPlan/BrandActivePlanModal/ActivePlanStepTwo'
import Modal from '@/Component/Common/Modal'
import ConfirmationModal from '@/Component/Common/Modal/ConfirmationModal'
import usePost from '@/Utils/Hooks/usePost'
import { CustomToast } from '@/Utils/CustomToast'
import SkeletonLoader from '@/Layout/SkeletonLoader'

let STRIPE_PUBLIC_KEY: any = process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const SavedCards = () => {
    const { translations } = useTranslation();
    const [selectCard, setSelectCard] = useState("");
    const [deleteCard, setDeleteCard] = useState("");
    const [cardType, setCardType] = useState("card_list");
    const [modal, setModal] = useState(null);

    // API GET
    const { data, isPending, refetch, fetchStatus } = useQuery({ queryKey: [CardsAPI], queryFn: () => CustomFetch({ url: CardsAPI }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data })

    // API DELETE
    const { isPending: deleteLoader, mutate: deleteCardMutate } = usePost(`${DeleteCardAPI}/${deleteCard}`, null, (response) => {
        if (response.status == 200 || response.status == 201) {
            CustomToast("success", translations?.cardDeleteSuccessfully)
            refetch()
            setDeleteCard('')
            setSelectCard('')
        }
    }, 'delete');

    const callbackFunction = () => {
        deleteCardMutate()
    }

    return (
        <>
            <div className='flex items-center justify-between gap-2 mb-6'>
                <h2 className="text-primary text-xl font-medium leading-6">💳 {translations?.savedCards}</h2>
                {data?.length > 0 &&
                    <GradientButton onClick={() => setCardType('add_card')} >{translations?.addNewCard}</GradientButton>
                    // <span className="text-black underline text-sm mt-2 cursor-pointer">
                    //     + {translations?.addNewCard}
                    // </span>
                }
            </div>
            {
                isPending && fetchStatus == 'fetching' ?
                    <div className='flex flex-col gap-2'>
                        <SkeletonLoader height={60} />
                        <SkeletonLoader height={60} />
                        <SkeletonLoader height={60} />
                    </div>
                    :
                    data?.length > 0
                        ?
                        data?.map((card, index) => (
                            <div key={index} className={`border-lightGray flex items-center justify-between px-4 py-2.5 border-2 rounded-lg mb-3 bg-lightGray/50`}>
                                <div className="flex items-center gap-4">
                                    <PayCardSVG />
                                    <div className="">
                                        <span className="text-base leading-5 block font-medium text-black">**** **** **** {card?.card_response?.card?.last4}</span>
                                        <div className="text-xs font-normal block text-gray capitalize">{card?.card_response?.card?.brand} - {translations?.expire} {card?.card_response?.card?.exp_month}/{card?.card_response?.card?.exp_year}</div>
                                    </div>
                                </div>
                                {data?.length > 1 && <div className="right flex items-center cursor-pointer" onClick={() => setDeleteCard(card.id)}>
                                    <PayCardDeleteSVG />
                                </div>}
                            </div>
                        ))
                        :
                        <div className='flex flex-col items-center justify-center p-5 border border-lightGray rounded-lg text-center gap-2'>
                            <span className='text-black text-base'>{translations?.noCardFound}</span>
                            {/* <span onClick={() => setCardType('add_card')} className='text-sm text-primary underline cursor-pointer'>{translations?.addNewCard}</span> */}
                            <GradientButton onClick={() => setCardType('add_card')} >{translations?.addNewCard}</GradientButton>
                        </div>
            }
            <Elements stripe={stripePromise}>
                {cardType == "add_card" &&
                    <Modal modalSize="w-96 max-w-4/5" modal={modal} setModal={setModal}><ActivePlanStepTwo modal={modal} setModal={setModal} cardType={cardType} setCardType={setCardType} refetch={refetch} translations={translations} /></Modal>}
            </Elements>
            {deleteCard && <ConfirmationModal loader={deleteLoader} modal={deleteCard} args={{ message: translations?.deleteCardMessage }} setModal={setDeleteCard} callbackFunction={callbackFunction} translations={translations} />}

        </>
    )
}

export default SavedCards
